import http from "@/utils/http"

let state = {
  allLoad: false, // 加载完成
  isLoad: true, // 正在加载
  noData: false, // 暂无数据
  gateInfoList: []
}
let actions = {
  queryGateInfoList (context, params) {
    http.post('p-app-gate-info-query', params).then(res => {
      state.isLoad = true
    })
  },
  openGate (context, params) {
    http.post('p-app-open-gate', params).then(res => {
      state.isLoad = true
    })
  },
  closeGate (context, params) {
    http.post('p-app-close-gate', params).then(res => {
      state.isLoad = true
    })
  },
  forceTrigger (context, params) {
    http.post('p-app-force-trigger', params).then(res => {
      state.isLoad = true
    })
  },
  plateFree (context, params) {
    http.post('p-app-plate-free', params).then(res => {
      state.isLoad = true
    })
  },
}
let mutations = {
  reGateInfo (state, data) {
    state.isLoad = true
    state.allLoad = false
    state.noData = false
    state.gateInfoList = []
  },
  setGateInfoList(state, data) {
    state.gateInfoList = data
    state.isLoad = false
    if(data && data.length > 0){
      state.allLoad = true
    } else {
      state.noData= true
    }
  },
  setDeviceInfo (state,data) {
    localStorage.setItem("gateIp", data.ip);
    localStorage.setItem("gateName", data.name);
  },
}


export default { state, actions, mutations }



// WEBPACK FOOTER //
// ./src/store/app/device/index.js